import React, { useEffect, useState } from 'react';
import { readPeopleNeeded } from '../utils/openShiftDay';

/**
 * The "People needed" box of an open shift — on a job's Open shift panel and
 * on the Calendar's "Route loose jobs" sheet, where it counts for the whole
 * day (everyone who claims does every job and is paid for every stop, so a
 * stray 21 matters).
 *
 * It keeps what was typed and only reads a number out of it, so the box can be
 * emptied and typed into on a phone: a number box that put "1" back the moment
 * it was empty turned a typed 2 into 21. Digits only, the number pad on a
 * phone, never above `max`; left empty, it goes back to the number it had.
 */
export default function PeopleNeededInput({ value, onChange, max = 20, id, className = 'input w-20 text-center py-1' }: {
  value: number; onChange: (n: number) => void; max?: number; id?: string; className?: string;
}) {
  const [text, setText] = useState(String(value));
  // The number changed from outside (the panel loaded, Edit was opened): show it — but never over what is being typed.
  useEffect(() => { setText(t => (readPeopleNeeded(t, max) === value ? t : String(value))); }, [value, max]);
  return (
    <input id={id} type="text" inputMode="numeric" pattern="[0-9]*" autoComplete="off" value={text} className={className}
      onFocus={e => e.target.select()}
      onChange={e => {
        const n = readPeopleNeeded(e.target.value, max);
        // Shown as read: "25" with a most of 20 shows 20, so the box never says a number that is not the one sent.
        setText(n == null ? e.target.value.replace(/\D/g, '').slice(0, 2) : String(n));
        if (n != null && n !== value) onChange(n);
      }}
      onBlur={() => setText(String(value))} />
  );
}
